module.exports = __webpack_public_path__ + "distribution/img/ico_fenxiang.fbb87839.png";